import React, { useMemo } from "react";
import { IconButton, LinearProgress, Paper, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Link } from "react-router-dom";

const sortIcon = <ArrowDownward />;

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        table: {
            minWidth: 650,
        },
    },
    btn: {
        margin: theme.spacing(4)
    }
}));

const TaskList = ({ channelsList, editGifts, deleteGifts, check, singleGiftsById }) => {
    const classes = useStyles();

    const heading = [
        {
            name: "Sr. No",
            wrap: true,
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            name: "Title",
            selector: "title",
            wrap: true,
            sortable: true,
        }, {
            name: "Link",
            selector: "link",
            wrap: true,
            sortable: true,
        }, {
            name: "Reward",
            selector: "reward",
            wrap: true,
            sortable: true,
        }, {
            name: "Reward Type",
            selector: "rewardType",
            wrap: true,

        },


        //  {
        //     name: "Image",
        //     selector: "bonus",
        //     wrap: true,
        //     sortable: true,
        //     cell: (channelsList) => (<div>
        //         <img style={{height: '60px', width: '60px'}} src={channelsList.image} alt="img"/>
        //     </div>)
        // }, 
        {
            name: "Action",
            wrap: true,
            center: true,
            cell: (channelsList) => (
                <div>
                    <Link to={"/dashboard/create-tasks/" + channelsList._id}>
                        <IconButton
                            edge="end"
                            aria-label="edit"

                        >
                            <EditIcon color="primary" />
                        </IconButton>
                    </Link>
                    {/* <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => {
                            deleteGifts(channelsList._id)
                        }}
                    >
                        <DeleteIcon color="primary"/>
                    </IconButton> */}
                </div>
            )
        }
    ];

    const safeData = Array.isArray(channelsList) ? channelsList : [];

    const columns = useMemo(
        () => [
            {
                name: "Sr. No",
                wrap: true,
                sortable: true,
                // index may be undefined depending on version; guard it
                cell: (row, index) =>
                    typeof index === "number" ? <div>{index + 1}</div> : <div>{safeData.findIndex((r) => r._id === row._id) + 1}</div>,
                width: "90px",
            },
            {
                name: "Title",
                selector: (row) => row.title ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Link",
                selector: (row) => row.link ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Reward",
                selector: (row) => row.reward ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Reward Type",
                selector: (row) => row.rewardType ?? "-",
                wrap: true,
            },
            {
                name: "Action",
                wrap: true,
                center: true,
                cell: (channelsList) => (
                    <div>
                        <Link to={"/dashboard/create-tasks/" + channelsList._id}>
                            <IconButton
                                edge="end"
                                aria-label="edit"

                            >
                                <EditIcon color="primary" />
                            </IconButton>
                        </Link>
                    </div>
                ),
                width: "140px",
            },
        ],
        [safeData]
    );

    return (
        <div>
            {!channelsList ? (
                <LinearProgress color="primary" />
            ) : (
                <Paper className={classes.paper} square>
                    <Link to='/dashboard/create-tasks'><Button variant="contained" color="primary" className={classes.btn}>Add Tasks</Button></Link>
                    {!check ?
                        <DataTable
                            columns={columns}
                            data={safeData}
                            noHeader
                            pagination
                            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                            // comment out sortIcon while debugging — enable only if it's a valid React node
                            // sortIcon={sortIcon}
                            striped
                            highlightOnHover
                            responsive
                        />
                        : ''}
                </Paper>
            )}
        </div>
    );
};

export default TaskList;
